/** Middleware overwrites this internal header with the actual requested path. */
export const SIGNUP_TRACKING_PATH_HEADER = "x-versafy-page-path"

export function isLoginTrackingPage(pathname: string | null, isAnonymous: boolean) {
  return pathname === "/" && isAnonymous
}
